/**
 * @description businessCommon整个当成一个大模块来处理。和页面平级。common里边的组件数据只能依赖这个里面的。非公共组件禁止用这个。即使用了有的数据也拿不到。
 */

import { IContextInfo, ICreatorInfo, IPageData } from '@umu/umu-types';
import Application from '../services/application';

// 仅仅几个公用
interface IBusinessCommonData extends IPageData {
    creatorInfo?: ICreatorInfo;
    contextInfo: IContextInfo;
}

class BusinessModuleService extends Application<IBusinessCommonData> {}
const templateData = Application.getModuleTemplateData() || {};
const data = templateData.data || {};
const config = templateData.config || {};
const commonModuleData: IBusinessCommonData = {
    Lang: config.lang,
    SYSTEM: config.system,
    siteHost: config.site_host,
    payChannel: config.pay_channel,
    userInfo: data.user_info || templateData.user_info || templateData.userInfo,
    creatorInfo: data.creator_info || templateData.creator_info,
    contextInfo: data.context_info || templateData.context_info,
};

const businessModuleService = new BusinessModuleService(commonModuleData);
const getModuleData = businessModuleService.getData;
export default businessModuleService;
export { getModuleData };
